import React, { useEffect, useState } from 'react'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import PropTypes from 'prop-types'
import { noop } from 'jquery'
import { notify } from '../../utils/helper'
import { errorMessage } from '../../constants/errorMessage'

const GooglePayDC = (props) => {
    // const [isRendered, setIsRendered] = useState(true)
    const [divChilds, setDivChilds] = useState(0)

    const {faciltyData, getValues, onSubmit, setIsSubmittingForm} = props
    useEffect(() => {
        const restrictedDiv = document.getElementById('google-pay-button')
        const childCount = restrictedDiv?.children?.length
        setDivChilds(childCount == 0 ? 1 : childCount)
    })

    useEffect(() => {
        function ensureSingleChild(div, newChild) {
            // If the div has more than one child, remove all but the last one
            while (div?.children?.length > 1) {
                div.removeChild(div?.firstElementChild)
            }
            // If the div has no children, simply append the new child
            if (div?.children?.length === 0) {
                div?.appendChild(newChild)
            } else {
                // Otherwise, replace the current child with the new child
                div?.replaceChild(newChild, div.firstElementChild)
            }
        }
        const restrictedDiv = document.getElementById('google-pay-button')
        // Example: Adding new content
        const newElement = document.createElement('p')
        // newElement.textContent = 'This is the new single child content.'
        // Call the function to ensure there's only one child in the div
        ensureSingleChild(restrictedDiv, newElement)
        return () => {
            console.log('')
        }
         
    },[EMPTY_ARRAY, divChilds])
    
    useEffect(() => {
        if (faciltyData?.payable_amount && divChilds == 1) {
            window.DatacapGooglePay.init(
                getToken(faciltyData),
                faciltyData?.facility?.facility_payment_details?.wallet_datacap_token,
                faciltyData?.facility?.facility_payment_details?.wallet_datacap_mid,
                faciltyData?.facility?.facility_payment_details?.wallet_datacap_gpay_merchant,
                Number(faciltyData?.payable_amount)?.toFixed(2),
            )
        }
        
    }, [EMPTY_ARRAY, faciltyData, divChilds])

   
    let googlePayWindow
    let intervalId

    const onGooglePayLoaded = () => {
        const originalOpen = window.open
        window.open = function(url, name, specs) {
            const newWindow = originalOpen(url, name, specs)
            if (url.startsWith('https://pay.google.com/')) {
                googlePayWindow = newWindow
                // Call API for Storing Logs
                monitorWindowClosed()
            }
            return newWindow
        }
    }

    const monitorWindowClosed = () => {
        intervalId = setInterval(() => {
            if (googlePayWindow && googlePayWindow.closed) {
                // Call API for Storing Logs
                clearInterval(intervalId)
            }
        }, 500)
    }

    document.addEventListener('DOMContentLoaded', () => {
        // Ensure onGooglePayLoaded is called after the Google Pay script is loaded
    })
    
        

    const getToken = (paymentData) => {
        onGooglePayLoaded()
        // Tokenization Callback
            const tokenCallback = function (tokenResponse) {
                return new Promise(function (resolve, reject) {
                    // If error, show error
                    if (tokenResponse.Error) {
                        alert('Token error: ' + tokenResponse.Error)
                        return
                    }
                    // If good, call Pay API
                    var token = tokenResponse.Token
                    var headers = {}
                    headers['Content-Type'] = 'application/json'
                    headers['Authorization'] = faciltyData?.facility?.facility_payment_details?.wallet_datacap_mid
                    headers['User-Agent'] = 'AwesomePOS/1.2.3'
                    console.log(token, tokenResponse)
                    var payApiRequest = [
                        { Amount: paymentData?.payable_amount ? Number(paymentData?.payable_amount)?.toFixed(2) : 0.00, Token: token }
                    ]
                    setIsSubmittingForm(true)
                    fetch(faciltyData?.facility?.facility_payment_details?.datacap_script_url, {
                        method: 'POST',
                        body: JSON.stringify(payApiRequest),
                        headers: headers
                    }).then(function (payApiResponse) {
                        payApiResponse?.json()?.then(function (json) {
                            setIsSubmittingForm(false)
                            if (payApiResponse?.status && payApiResponse?.status != 200) {
                                notify('error', 'Error: ' + json.Message)
                                const formData = getValues()
                                const finalData = {...formData, walletPay : json}
                                finalData.paymentMethod = 'GPAY'
                                reject('Error' + json.Message)
                                console.log(json, json.Message)
                                onSubmit(finalData)
                            }
                            else {
                                const formData = getValues()
                                const finalData = {...formData, walletPay: json}
                                finalData.paymentMethod = 'GPAY'
                                resolve('Approved' + json.Message)
                                console.log(json, json.Message)
                                onSubmit(finalData)
                            }
                        })
                    }).catch((err) => {
                        setIsSubmittingForm(false)
                        notify('error', err ? err : errorMessage?.somethingWentWrong )
                    })
                }).catch((err) => {
                    notify('error', err ? err : errorMessage?.somethingWentWrong )
                })
            }	
            return tokenCallback
        }

    return (
            <div className="payButton mt-2 px-2 d-flex justify-content-center" id='google-pay-button'></div>
    )
}
GooglePayDC.propTypes = {
   faciltyData: PropTypes.object, 
   getValues: PropTypes.func, 
   onSubmit: PropTypes.func,
   setIsSubmittingForm: PropTypes.func,
}

GooglePayDC.defaulProps = {
    faciltyData: EMPTY_OBJECT,
    getValues: noop, 
    onSubmit: noop,
    setIsSubmittingForm: noop,
}
export default GooglePayDC
